<template>
  <div>
    <hol-replace-select-date-header />
    <!--select-date-title-hol-replace
      :activeTab="activeTab"
    ></select-date-title-hol-replace-->
    <select-date-content-hol-replace
      @selectDate="selectDate"
    ></select-date-content-hol-replace>
  </div>
</template>
<script>
import HolReplaceSelectDateHeader from '@/components/application/form/HolReplaceSelectDateHeader.vue';
import SelectDateContentHolReplace from '@/components/application/form/SelectDateContentHolReplace.vue';
//import SelectDateTitleHolReplace from '@/components/application/form/SelectDateTitleHolReplace.vue';

import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';

import { mapGetters } from 'vuex';
//import applCode from '@/const/applCodeConstants';

export default {
  mixins: [applCdMixin],
  components: {
    HolReplaceSelectDateHeader,
    SelectDateContentHolReplace,
    //SelectDateTitleHolReplace,
  },
  data: () => ({
    activeTab: 'E',
    type: '',
  }),
  computed: {
    ...mapGetters('ELA', ['GET_S_YMD', 'GET_E_YMD']),
    ...mapGetters(['GET_APPL_CD', 'GET_RETURNYMD', 'GET_APPL_TYPE']),
  },
  methods: {
    async selectDate() {
      this.$router.push(routerNames.HolReplaceSubView);
      this.OFF_APP_SPINNER();
    },
  },
  mounted() {
    this.$store.commit('SET_PARAMS', []);
    this.$store.commit('setHolReplacePeriodParam', []);
    this.$store.commit('SET_FILE_SEQ', '');
  },
  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
};
</script>
<style></style>
